import React from 'react'

import { useDialogState } from '../components'

export const withDialogState = (Component: any) => (props: any) => {
  const dialogState = useDialogState()
  return <Component dialogState={dialogState} {...props} />
}
